import { render, staticRenderFns } from "./risktypeEdit.vue?vue&type=template&id=e2de8bc0"
import script from "./risktypeEdit.vue?vue&type=script&lang=js"
export * from "./risktypeEdit.vue?vue&type=script&lang=js"
import style0 from "./risktypeEdit.vue?vue&type=style&index=0&id=e2de8bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports